import io from "socket.io-client";
import store from "@/store";
import { checkSelf, checkSelfRole } from "@/common/role_utils";
import { Employee } from "@/api";
import moment from "moment";
import { monthStamp } from "./beginAtEndAt";

const serverUrl = process.env.VUE_APP_BASE_API_URL?.replace("/v1", "");

type MessageReq = {
  id: number;
  companyId: number;
  from: number;
  to?: number;
  group?: number;
  message: string;
  media?: string;
};

type NotificationType = {
  to: number;
  message: string;
  type: string;
  submitter: Employee;
};

let socket: SocketIOClient.Socket;

const connect = (id: number, username: string, companyId: number) => {
  if (!serverUrl) return false;
  socket = io(serverUrl, {
    transports: ["websocket"],
  });

  socket.on("connect", () => {
    socket.emit("/auth", {
      author: id,
      message: "Hello, Server",
      username,
      companyId,
    });
  });
  socket.on("connect_error", (err: Error) => {
    console.log("Failed to connect: ", err);
  });
  socket.on("disconnect", () => {
    console.log("Socket disconnected");
  });
  socket.on("reconnect_attempt", (attemptNumber: number) => {
    console.log(`Reconnecting attempt #${attemptNumber}`);
  });
  return true;
};

const updateType = (
  type: string,
  routeTarfStatus: number,
  documentId: number,
  status: number,
  submitter: Employee,
) => {
  const stamp = monthStamp();
  const startDate = moment()
    .startOf("week")
    .format("YYYY-MM-DD");
  const endDate = moment()
    .endOf("week")
    .format("YYYY-MM-DD");
  switch (type.toLowerCase()) {
    case "tarf":
      store.dispatch("tarf/fetchTarfStatuses", {
        force: false,
        toFetch: routeTarfStatus,
      });
      break;

    case "document":
      if (checkSelfRole("owner")) {
        store.dispatch("employeeDocuments/getEmployeeDocumentCount");
        if (status >= 0) {
          store.dispatch("employeeDocuments/getApprovalDocumentList", {
            approval: status,
          });
        }
      }
      if (checkSelfRole("owner") || checkSelfRole("admin")) {
        store.dispatch("employeeDocuments/getCompanyDocumentCount");
        if (documentId >= 0) {
          store.dispatch("employeeDocuments/getOwnerDocumentList", {
            documentId: documentId,
          });
        }
      }
      if (checkSelfRole("employee") || checkSelf(submitter?.id)) {
        store.dispatch("employeeDocuments/getSelfDocumentCount");
        if (documentId >= 0) {
          store.dispatch("employeeDocuments/getDocumentList", {
            departmentDocumentId: documentId,
          });
        }
      }

      break;

    case "event":
      store.dispatch("EventMetricAdmin/fetchEventCount", {
        eventId: -1,
        date: moment()
          .local()
          .format("YYYY-MM-DD"),
      });
      break;

    case "unread message":
      store.dispatch("chat/fetchUnreadMessageCount");
      store.dispatch("chat/fetchChatList");
      store.dispatch("chat/fetchGroupList");
      break;

    case "announcement":
      if (!checkSelf(submitter.id)) {
        store.dispatch("announcement/fetchAnnouncements");
      }
      break;

    case "suggestion":
      store.dispatch("suggestion/fetchSuggestions", {
        benefit: undefined,
        beginAt: stamp.beginAt,
        endAt: stamp.endAt,
      });

      store.dispatch("suggestion/fetchLikelyBenefits", {
        beginAt: stamp.beginAt,
        endAt: stamp.endAt,
        force: true,
      });
      break;

    case "budget":
      store.dispatch("categoryBudget/fetchUpdatedBudget");
      store.dispatch("categoryBudget/fetchUpdatedExpenses");
      break;

    case "expenses":
      store.dispatch("categoryBudget/fetchUpdatedExpenses");
      break;

    case "room-status":
      store.dispatch("room/fetchRoomsStatus");
      store.dispatch("room/fetchRoomsStatusCount");
      break;

    case "patient-calendar":
      store.dispatch("patientCalendar/fetchCount");
      break;

    case "staff-calendar":
      store.dispatch("calendar/fetchCount");
      break;

    case "log_event":
      // store.dispatch("activity/loadActivityFeed");
      break;

    case "guardian-angel":
      store.dispatch("inspection/fetchInspectionCount", {
        beginAt: startDate,
        endAt: endDate,
      });
      break;

    case "schedule":
    case "schedule-census":
      store.commit("schedule/SOCKET_REFRESH");
      break;

    case "staff-survey/category":
      store.dispatch("staffSurvey/getCategories");
      break;

    case "navigation":
      store.dispatch("navigation/fetchFeature");
      break;

    default:
      break;
  }
};

export { connect, socket, updateType, MessageReq, NotificationType };
